import { Home, Expand, Zap, Wrench, Layers, UtensilsCrossed, Bath, FileText, ArrowRight } from "lucide-react";
import { Reveal, Kicker } from "./Reveal";
import { SERVICES } from "../../data/site";
import { scrollToSection } from "../../lib/scroll";

const ICONS = { Home, Expand, Zap, Wrench, Layers, UtensilsCrossed, Bath };

export const Services = () => (
  <section
    id="services"
    data-testid="services-section"
    className="border-y border-black/5 bg-coal py-24 md:py-36"
  >
    <div className="mx-auto max-w-7xl px-6">
      <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
        <div>
          <Reveal>
            <Kicker index="02" label="What We Do" />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-5xl font-bold uppercase tracking-tight text-ink md:text-6xl">
              Our Expertise
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <p className="max-w-sm text-sm leading-relaxed text-fog">
            From loft conversions to bathrooms — one accountable in-house team
            covers every trade on your project, with free written quotes on all
            work.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-px border border-black/10 bg-black/10 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((service, i) => {
          const Icon = ICONS[service.icon];
          return (
            <Reveal key={service.n} delay={i * 0.06} className="h-full">
              <article
                data-testid={`service-card-${service.n}`}
                className="group flex h-full flex-col bg-white p-6 transition-colors duration-500 hover:bg-steel"
              >
                <div className="relative mb-6 h-40 overflow-hidden">
                  <img
                    src={service.img}
                    alt={service.title}
                    className="h-full w-full object-cover grayscale-[40%] transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
                    loading="lazy"
                  />
                  <span className="absolute right-3 top-2 font-display text-5xl font-extrabold text-outline-bronze">
                    {service.n}
                  </span>
                </div>
                <div className="mb-4 grid h-10 w-10 place-items-center border border-bronze/40">
                  <Icon className="h-4.5 w-4.5 h-5 w-5 text-bronze" strokeWidth={1.8} />
                </div>
                <h3 className="font-display text-xl font-bold uppercase leading-tight tracking-wide text-ink">
                  {service.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-fog">
                  {service.desc}
                </p>
                <button
                  data-testid={`service-cta-${service.n}`}
                  onClick={() => scrollToSection("#contact")}
                  className="mt-6 flex w-fit items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-bronze transition-colors duration-300 hover:text-ink"
                >
                  Discuss your project
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                </button>
              </article>
            </Reveal>
          );
        })}

        <Reveal delay={0.45} className="h-full">
          <div
            data-testid="service-card-free-quotes"
            className="bg-gold-shine flex h-full flex-col justify-between p-6"
          >
            <div>
              <div className="mb-4 grid h-10 w-10 place-items-center border border-ink/30">
                <FileText className="h-5 w-5 text-ink" strokeWidth={1.8} />
              </div>
              <h3 className="font-display text-3xl font-extrabold uppercase leading-none tracking-wide text-ink">
                Free Quotes
              </h3>
              <p className="mt-4 text-sm font-medium leading-relaxed text-ink/80">
                Every project starts with a free, no-obligation written
                quotation — itemised, fixed and valid for 30 days.
              </p>
            </div>
            <button
              data-testid="service-cta-free-quotes"
              onClick={() => scrollToSection("#contact")}
              className="mt-8 flex w-fit items-center gap-3 border border-ink/30 bg-white px-6 py-3.5 text-xs font-semibold uppercase tracking-[0.25em] text-ink transition-colors duration-300 hover:bg-ink hover:text-bronze"
            >
              Get my free quote
              <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
